import React, { createContext, useContext, useState } from 'react';

const LangContext = createContext(null);

const translations = {
  es: {
    // Nav
    dashboard: 'Dashboard',
    fichajes: 'Fichajes',
    empleados: 'Empleados',
    analisis: 'Análisis',
    anomalias: 'Anomalías',
    sincronizacion: 'Sincronización',
    configuracion: 'Configuración',
    turnos: 'Turnos por centro',
    notificaciones: 'Notificaciones',
    trazabilidad: 'Trazabilidad',
    reportes: 'Reportes',
    ayuda: 'Manual',
    cerrarSesion: 'Cerrar sesión',
    admin: 'Gestión de accesos',
    // Login
    loginTitle: 'Control de jornada inteligente',
    loginSub: 'KPIs automáticos, corrección de incidencias y sincronización segura con Azure AD y SFTP.',
    loginSsoBtn: 'Continuar con Microsoft',
    loginEmergency: 'Acceso de emergencia',
    loginEmail: 'Correo electrónico',
    loginPassword: 'Contraseña',
    loginSubmit: 'Entrar',
    loginError: 'Credenciales incorrectas',
    // KPIs
    correctos: 'Correctos',
    autoCerrados: 'Turnos sin salida',
    horasTotales: 'Horas totales',
    distribucionTurno: 'Por turno',
    // Status
    correcto: 'Correcto',
    autoCerrado: 'Fichaje cerrado automáticamente',
    faltaFichaje: 'Falta fichaje salida',
    // Shifts
    manana: 'Mañana',
    tarde: 'Tarde',
    noche: 'Noche',
    // Table cols
    empleado: 'Empleado',
    fecha: 'Fecha',
    turno: 'Turno',
    entrada: 'Entrada',
    salida: 'Salida',
    horas: 'Horas',
    estado: 'Estado',
    dispositivo: 'Dispositivo',
    fichajes_col: 'Fichajes',
    // Filters
    buscar: 'Buscar empleado...',
    filtrarPorTurno: 'Turno',
    filtrarPorEstado: 'Estado',
    filtrarPorCentro: 'Centro',
    fechaInicio: 'Fecha inicio',
    fechaFin: 'Fecha fin',
    exportar: 'Exportar CSV',
    limpiarFiltros: 'Limpiar filtros',
    // Sync
    syncNow: 'Sincronizar ahora',
    syncRunning: 'Sincronización en curso...',
    ultimaSync: 'Última sincronización',
    proximaSync: 'Próxima sincronización',
    logsSync: 'Historial de sincronizaciones',
    syncSuccess: 'Sincronización completada',
    syncError: 'Error en sincronización',
    // Employees
    activo: 'Activo',
    inactivo: 'Inactivo',
    sinDatos: 'Sin datos del directorio',
    puesto: 'Puesto',
    organizacion: 'Organización',
    centroCosto: 'Centro de coste',
    // General
    cargando: 'Cargando...',
    sinResultados: 'Sin resultados',
    pagina: 'Página',
    de: 'de',
    mostrar: 'Mostrar',
    porPagina: 'por página',
  },
  en: {
    dashboard: 'Dashboard',
    fichajes: 'Time Records',
    empleados: 'Employees',
    analisis: 'Analytics',
    anomalias: 'Anomalies',
    sincronizacion: 'Sync',
    configuracion: 'Settings',
    turnos: 'Shifts per Center',
    notificaciones: 'Notifications',
    trazabilidad: 'Traceability',
    reportes: 'Reports',
    ayuda: 'User Manual',
    cerrarSesion: 'Sign out',
    admin: 'Access Management',
    loginTitle: 'Intelligent time tracking',
    loginSub: 'Automatic KPIs, incident correction and secure sync with Azure AD and SFTP.',
    loginSsoBtn: 'Continue with Microsoft',
    loginEmergency: 'Emergency access',
    loginEmail: 'Email address',
    loginPassword: 'Password',
    loginSubmit: 'Sign in',
    loginError: 'Invalid credentials',
    correctos: 'Correct',
    autoCerrados: 'Shifts without exit',
    horasTotales: 'Total hours',
    distribucionTurno: 'By shift',
    correcto: 'Correct',
    autoCerrado: 'Auto-closed punch',
    faltaFichaje: 'Missing exit punch',
    manana: 'Morning',
    tarde: 'Afternoon',
    noche: 'Night',
    empleado: 'Employee',
    fecha: 'Date',
    turno: 'Shift',
    entrada: 'Clock In',
    salida: 'Clock Out',
    horas: 'Hours',
    estado: 'Status',
    dispositivo: 'Device',
    fichajes_col: 'Punches',
    buscar: 'Search employee...',
    filtrarPorTurno: 'Shift',
    filtrarPorEstado: 'Status',
    filtrarPorCentro: 'Center',
    fechaInicio: 'Start date',
    fechaFin: 'End date',
    exportar: 'Export CSV',
    limpiarFiltros: 'Clear filters',
    syncNow: 'Sync now',
    syncRunning: 'Sync in progress...',
    ultimaSync: 'Last sync',
    proximaSync: 'Next sync',
    logsSync: 'Sync history',
    syncSuccess: 'Sync completed',
    syncError: 'Sync error',
    activo: 'Active',
    inactivo: 'Inactive',
    sinDatos: 'No directory data',
    puesto: 'Position',
    organizacion: 'Organization',
    centroCosto: 'Cost center',
    cargando: 'Loading...',
    sinResultados: 'No results',
    pagina: 'Page',
    de: 'of',
    mostrar: 'Show',
    porPagina: 'per page',
  }
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState('es');
  const t = (key) => translations[lang][key] || key;
  const toggleLang = () => setLang(l => l === 'es' ? 'en' : 'es');
  return (
    <LangContext.Provider value={{ lang, t, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
